export function getLumivivUrl(language: string | undefined): string {
  if (language === 'ja-JP') return 'https://www.lumiviv.co.jp/';
  if (language === 'en-US') return 'https://www.lumiviv.co.jp/en';
  return 'https://www.lumiviv.co.jp/zh';
}
